<template>
  <div class="banner-form">
    <div class="main-title">
      <p>
        <span class="bold-text" @click="back">banner管理</span>
        <span>&gt;</span>
        <span style="font-weight: 400">{{ subtitle }}</span>
      </p>
    </div>
    <div class="main-body">
      <div class="form-container">
        <el-form ref="form" :model="formData" :rules="rules" label-width="100px" label-position="left"
                 hide-required-asterisk validate-on-rule-change>
          <el-form-item label="图片链接：" prop="imageUrl">
            <el-input type="textarea" clearable :autosize="{ minRows: 4, maxRows: 10}" v-model="formData.imageUrl"
                      placeholder="请输入图片链接"></el-input>
            <div v-if="formData.imageUrl"
                 style="padding: 20px 0; display: flex; align-items: center; justify-content: space-between">
              <el-image :src="formData.imageUrl" style="width: 100%" fit="fill" alt="">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button type="primary" @click="back">取消</el-button>
          <el-button type="primary" @click="onSubmit">确认{{ type === 1 ? '新增' : '修改' }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "marketingActivityForm",
  props: {
    type: {
      type: Number,
      default: 1
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    const data = this.data;
    let formData;
    if (data.number) {
      formData = {
        number: data.number,
        imageUrl: data.imageUrl
      };
    } else {
      formData = {
        number: '',
        imageUrl: ''
      };
    }
    return {
      formData: formData,
      rules: {
        imageUrl: [
          {required: true, message: '请输入图片链接', trigger: 'blur'},
        ],
      },
    }
  },


  watch: {},

  computed: {
    subtitle() {
      return this.type === 1 ? '新增' : '编辑'
    }
  },

  mounted() {

  },

  methods: {
    back() {
      this.$emit('back')
    },


    onSubmit() {
      const form = this.$refs.form;
      form.validate((valid) => {
        if (valid) {
          this.createOrUpdate({...this.formData})
        } else {
          return false;
        }
      });
    },

    createOrUpdate(params) {
      this.$http.post('/managementPlatform/admin/createOrUpdateBanner', this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.$message.success("操作成功")
        this.$emit('back', true)
      }).catch(function (response) {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-form {
  .filter-bar {
    display: flex;
    align-items: center;

    .item {
      margin-right: 10px;
      min-width: 260px;

      .el-input {
        width: 160px;
      }

      .el-cascader,
      .el-select,
      .el-date-editor {
        width: 200px;
      }
    }
  }

  .main-body {
    .form-container {
      width: 400px;

      .el-cascader,
      .el-select {
        width: 300px;
      }

      .buttons {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding: 20px 0;

        .el-button {
          min-width: 100px;
        }
      }
    }
  }

  .table-custom {
    th, td {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/bannerForm.vue